/* Myco Pet product gallery arrows.
   Adds semi-transparent previous/next arrows (and swipe on touch screens) to the main product photo.
   They step through the same photos as the thumbnail strip by pressing the matching thumbnail,
   so the page's own gallery code still does the image swap. */
(function () {
  if (window.__mycoGallery) return;
  window.__mycoGallery = true;

  var lang = (document.documentElement.lang || 'en').slice(0, 2);
  var L = { en: ['Previous photo', 'Next photo'], fr: ['Photo précédente', 'Photo suivante'], es: ['Foto anterior', 'Foto siguiente'] }[lang] || ['Previous photo', 'Next photo'];

  var css = '' +
    '.mpd-main{position:relative}' +
    '.mga{position:absolute;top:50%;z-index:3;transform:translateY(-50%);display:flex;align-items:center;justify-content:center;width:44px;height:44px;padding:0;border:0;border-radius:50%;' +
    'background:rgba(255,255,255,.55);color:#071A33;-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px);box-shadow:0 4px 14px -6px rgba(7,26,51,.45);cursor:pointer;opacity:.9;transition:opacity .15s,background .15s}' +
    '.mga:hover{background:rgba(255,255,255,.85);opacity:1}' +
    '.mga:focus-visible{outline:3px solid #007FFF;outline-offset:2px;opacity:1}' +
    '.mga--prev{left:10px}.mga--next{right:10px}' +
    '.mga svg{width:22px;height:22px;display:block}' +
    '@media (hover:hover) and (min-width:900px){.mga{opacity:0}.mpd-main:hover .mga,.mga:focus-visible{opacity:.9}}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var chev = function (d) {
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + (d < 0 ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  };

  function setup(gal) {
    if (gal.__mga) return;
    var main = gal.querySelector('.mpd-main');
    var strip = gal.querySelector('.mpd-thumbs');
    if (!main || !strip) return;
    var thumbs = function () { return [].slice.call(strip.querySelectorAll('.mpd-thumb')); };
    if (thumbs().length < 2) return;
    gal.__mga = true;

    function go(step) {
      var t = thumbs();
      var i = t.findIndex(function (b) { return b.getAttribute('aria-pressed') === 'true'; });
      if (i < 0) i = 0;
      var n = (i + step + t.length) % t.length;
      t[n].click();
      // keep the active thumbnail visible in the strip without scrolling the page
      var b = t[n], left = b.offsetLeft - strip.offsetLeft, right = left + b.offsetWidth;
      if (left < strip.scrollLeft) strip.scrollTo({ left: left - 8, behavior: 'smooth' });
      else if (right > strip.scrollLeft + strip.clientWidth) strip.scrollTo({ left: right - strip.clientWidth + 8, behavior: 'smooth' });
    }

    [-1, 1].forEach(function (d) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mga ' + (d < 0 ? 'mga--prev' : 'mga--next');
      b.setAttribute('aria-label', d < 0 ? L[0] : L[1]);
      b.innerHTML = chev(d);
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(d); });
      main.appendChild(b);
    });

    // swipe on touch screens
    var x0 = null, y0 = null;
    main.addEventListener('touchstart', function (e) { if (e.touches.length !== 1) return; x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      x0 = y0 = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) go(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  function init() { [].forEach.call(document.querySelectorAll('.mpd-gal'), setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
